import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import Sms from '@lib/pages/Sms';
import { IStoreSiteState } from '@lib/types/index';
import { connect, Dispatch } from 'react-redux';
import { withRouter } from 'react-router';



export function mapStateToProps(state: any): ISmsProps {
  const site: IStoreSiteState = state.site;
  let devId = '';
  let m1 = '';
  if (site.site !== undefined && site.site!.device !== undefined) {
    devId = site.site!.device!.id;
    if (site.site!.device!.m1 !== undefined) {
      m1 = site.site!.device!.m1!;
    }
  }
  return addTranslateToProps({
    deviceId: devId,
    errorMessage: site.errorMessage,
    m1,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGoHome: () => window.history.back(),
  }
}

export interface ISmsProps extends ITranslationProps {
  deviceId: string;
  m1: string;
  errorMessage: string;
}

interface ISmsDispatchProps {
  onGoHome(): void;
}

export type SmsProps = ISmsProps & ISmsDispatchProps;

export default withRouter(connect<ISmsProps, ISmsDispatchProps, any>(mapStateToProps, mapDispatchToProps)(Sms));


// WEBPACK FOOTER //
// ./src/containers/Sms.tsx